export default __webpack_public_path__ + "static/media/trafic-colour-1.7e3994f6.jpg";